export default {
    urlDefaultPath: null
}
